export default __webpack_public_path__ + "342247d85cd451ea1fed48f755749deb.jpg";